import type { ApiRet } from '@spx-portal/shared-types';

import { request } from '@/common/appCtx';

import { GetWorkstationActivityTypeParams, GetWorkstationActivityTypeRes, SetWorkstationActivityTypeParams } from './type';

export async function getWorkstationActivityType(params: GetWorkstationActivityTypeParams): Promise<GetWorkstationActivityTypeRes> {
  return request
    .get('/api/wfm/admin/workstation/workstation_activity_type_list', { params })
    .then((v: ApiRet) => v.data);
}

export async function setWorkstationActivityType(params: SetWorkstationActivityTypeParams): Promise<void> {
  return request
    .post('/api/wfm/admin/workstation/workstation_activity_type_set', params)
    .then((v: ApiRet) => v.data);
}
